module.exports = __webpack_public_path__ + "static/media/crm_img1.f2bc61c7.jpg";